<div>
  <div class="row">
    <div class="p-sm-3">
      <h4>{{'my_templates_title' | i18n}}</h4>
    </div>
  </div>
  <kendo-grid class="pointer" [data]="gridView$ | async" (cellClick)="cellClickHandler($event)">
    <ng-template kendoGridToolbarTemplate>
      <input
        [placeholder]="'template_search_input' | i18n"
        kendoTextBox
        (input)="onFilter($event.target.value)"
        style="width: auto"
      />
    </ng-template>
    <!-- mobile view -->
    <kendo-grid-column [title]="'my_templates_title' | i18n" media="(max-width: 571px)">
      <ng-template kendoGridCellTemplate let-x>
        <div class="d-flex flex-row justify-content-between ">
          <div class="d-flex flex-column flex-1" >
            <h5 style="font-size: 24px;">
              {{ x.title }}
            </h5>
            <div class="d-flex flex-row align-center">
              <span>{{'templates_grid_duration' | i18n}}: {{ x.duration }}</span>
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column [title]="'templates_grid_title' | i18n"  media="(min-width: 571px)">
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.title }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'templates_grid_duration' | i18n"  media="(min-width: 571px)">
      <ng-template kendoGridCellTemplate let-x>
        <span class="nobr">{{ x.duration }}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-messages [noRecords]="'kendo_noRecords' | i18n">
    </kendo-grid-messages>
  </kendo-grid>
</div>
